// extracted by mini-css-extract-plugin
export default {"note":"chatNote_note__n0xdl","loader":"chatNote_loader__PfMXL","l1":"chatNote_l1__0aOPm"};